// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1TtKj","formContainer":"App_formContainer__EqHyi","formInput":"App_formInput__29QKD","formAdd":"App_formAdd__nq8fh","todos":"App_todos__1YefD"};